import { render } from "./AiCourse.vue?vue&type=template&id=202ba8e2&scoped=true"
import script from "./AiCourse.vue?vue&type=script&lang=js"
export * from "./AiCourse.vue?vue&type=script&lang=js"

import "./AiCourse.vue?vue&type=style&index=0&id=202ba8e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202ba8e2"]])

export default __exports__